"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unarchivedOrgTagsForType = exports.TagType = void 0;
var Tag = /** @class */ (function () {
    function Tag() {
        this.organizationId = null;
        this.id = null;
        this.type = null;
        this.name = null;
        this.isArchived = false;
    }
    return Tag;
}());
exports.default = Tag;
var TagType;
(function (TagType) {
    TagType["AREA_OF_OPERATION"] = "area_of_operation";
    TagType["AGE_DIVISION"] = "age_division";
    TagType["COMPETITION_GENDER"] = "competition_gender";
    TagType["COMPETITION_LEVEL"] = "competition_level";
})(TagType = exports.TagType || (exports.TagType = {}));
var unarchivedOrgTagsForType = function (orgTags, tagType) {
    return (orgTags === null || orgTags === void 0 ? void 0 : orgTags.filter(function (tag) { return tag.type === tagType && !tag.isArchived; }).sort(function (a, b) { return a.id - b.id; })) || [];
};
exports.unarchivedOrgTagsForType = unarchivedOrgTagsForType;
//# sourceMappingURL=tag.js.map